import type { Dataset } from '@k-ucap/shared';
import type { DatasetRepository } from './RepositoryInterfaces.js';

const datasets: Map<string, Dataset> = new Map();

export class InMemoryDatasetRepository implements DatasetRepository {
  async findAll(): Promise<Dataset[]> {
    return Array.from(datasets.values()).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }

  async findById(id: string): Promise<Dataset | undefined> {
    return datasets.get(id);
  }

  async findByProjectId(projectId: string): Promise<Dataset[]> {
    return Array.from(datasets.values())
      .filter((d) => d.projectId === projectId)
      .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }

  async save(dataset: Dataset): Promise<Dataset> {
    datasets.set(dataset.id, dataset);
    return dataset;
  }

  async delete(id: string): Promise<void> {
    datasets.delete(id);
  }

  async duplicate(id: string, newName?: string): Promise<Dataset | undefined> {
    const original = await this.findById(id);
    if (!original) return undefined;
    const duplicated: Dataset = {
      ...original,
      id: `dataset-${Date.now()}`,
      name: newName ?? `${original.name} (Copy)`,
      parentId: original.id,
      revision: 1,
      updatedAt: new Date().toISOString(),
    };
    await this.save(duplicated);
    return duplicated;
  }
}

export const createInMemoryDatasetRepository = (): InMemoryDatasetRepository => new InMemoryDatasetRepository();
